import React from "react";
import {Builder} from "../../../_metronic/_partials/builder/Builder";

export function BuilderPage() {
    return <Builder />;
}
